import { DatePicker, Modal } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startEstablecerCita } from "../../../context/actions/detalleActions";

export const ModalCita = ({ show, close }) => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();
  const [fechaCita, setFechaCita] = useState("");
  const [cargando, setCargando] = useState(false);
  const handleChange = (f, fString) => setFechaCita(fString);
  const handleOk = async () => {
    if (fechaCita === "") {
      close();
      return;
    }
    const body = {
      fechaCita,
      asistenciaID,
    };
    setCargando(true);
    const ok = await dispatch(startEstablecerCita(body));
    setCargando(false);
    if (ok) {
      setFechaCita("");
      close();
    }
  };
  return (
    <Modal
      title="Establecer Cita"
      open={show}
      onOk={handleOk}
      onCancel={() => close()}
      confirmLoading={cargando}
    >
      <DatePicker onChange={handleChange} showTime style={{ width: "100%" }} />
    </Modal>
  );
};
